import React from 'react';
import Select, { SelectProps } from 'antd/lib/select';
import { useQuery } from 'react-query';

import { getMyAuthorizedUsersList } from 'services/parametersService';

export type AuthorizedUsersProps = SelectProps<any>;

const AuthorizedUsersInput = (props: AuthorizedUsersProps) => {
  const { data } = useQuery(
    ['getMyAuthorizedUsersList'],
    () => getMyAuthorizedUsersList().then((res) => res.list || []),
    {
      staleTime: 60 * 1000,
    }
  );

  return (
    <Select autoClearSearchValue {...props} allowClear>
      {data?.map(({ name, userid }) => (
        <Select.Option value={userid} key={userid}>
          {name}
        </Select.Option>
      ))}
    </Select>
  );
};

export default AuthorizedUsersInput;
